export function setMaxAmountForCartItem({cartItem}) {
    const {amount, maxPerCustomerLeftover} = cartItem
    let maxAmount = amount + maxPerCustomerLeftover

    if (maxAmount > cartItem.maxPerCustomer) {
        maxAmount = cartItem.maxPerCustomer
    }
    
    return {...cartItem, maxAmount}
  }